/**
 * F15/D205 — o número curto do pedido como a cozinha e o balcão o falam: `42` vira `#042`. Três dígitos
 * porque é o volume de um estabelecimento num dia; acima disso o número sai inteiro (`#1234`).
 *
 * Um formatador só, para o ticket, o extrato e o painel: se cada ponta formatasse, o papel diria `#42` e a
 * tela `#042`, e o operador desconfiaria que são pedidos diferentes.
 */
export function formatDailyOrderNumber(dailyNumber: number): string {
  return `#${String(dailyNumber).padStart(3, '0')}`;
}
